<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-select v-model="selectedState" size="large" @change="onChangeFilter" placeholder="Status">
        <el-option v-for="status in Object.keys(statuses)" :value="status" :label="statuses[status].text"
                   :key="status"></el-option>
      </el-select>
    </div>
    <el-table :data="questions" class="table" border height="calc(100vh - 263px)">
      <el-table-column type="index" label="T/R"></el-table-column>
      <el-table-column prop="phoneNumber" label="Telefon raqami"/>
      <el-table-column prop="lang" label="Tili"></el-table-column>
      <el-table-column prop="state" label="Holati" align="center">
        <template #default="scope">
          <el-tag :type="statuses[scope.row.state].type">
            {{ statuses[scope.row.state].text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #default="scope">
          <el-button @click="callDone(scope.row.id)" type="primary">Qo'ng'iroq qilindi</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              hide-on-single-page
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15,20,30,50,100,200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "CallMeBackRequests",
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  data() {
    return {
      loading: false,
      selectedState: "NEW",
      statuses: {
        NEW: {text: 'YANGI', type: ''},
        CLOSED: {text: 'YOPILGAN', type: 'success'},
      },
      questions: [],

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,

      cancelingReasons: [],

      declineDialog: false,
      acceptDialog: false,
      declineForm: {
        questionId: null,
        context: null,
      },
      acceptForm: {
        questionId: null,
        context: null,
      },

      rules: {
        context: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, size: val, page: this.page},
          }).then(() => {
        this.getCallMeBackRequests();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getCallMeBackRequests();
      }).catch(() => {
      });
    },

    onChangeFilter() {
      this.page = 1;
      this.$router.replace({query: {...this.$route.query, status: this.selectedState}})
      this.getCallMeBackRequests()
    },
    callDone(id) {
      this.loading = true
      this.$http.put(`api/v2/info/suggestions/call-me-back/${id}`, null, {
        params: {
          state: 'CLOSED'
        }
      }).then(() => {
        ElNotification.success({message: "Qayta qo'ng'iroq so'rovi bajarildi"})
        this.getCallMeBackRequests()
      }).catch(() => {
        ElNotification.error({message: "Amaliyot bajarishda xatolik sodir bo'ldi. Iltimos qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
    getCallMeBackRequests() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size ? parseInt(this.$route.query.size || "") : 20;
      this.$http.get(`api/v2/info/suggestions/call-me-back`, {
        params: {
          state: this.selectedState,
          page: this.page - 1,
          size: this.size
        }
      }).then(({data}) => {
        this.questions = data.content
        this.totalElements = data.totalElements;
        this.totalPages = data.totalPages;
        this.size = data.size;
      }).catch((err) => {
        console.log(err)
        ElNotification.error({message: "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta yuklang ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },

  mounted() {
    if (this.$route.query.status) {
      this.selectedState = this.$route.query.status
    }
    this.$nextTick(() => {
      this.getCallMeBackRequests();
    })
  }

}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 3px;
  height: 40px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>